import { Navbar, Footer } from "@/components/landing";
import { DubcircusCaseStudy } from "@/components/work/dubcircus/DubcircusCaseStudy";

export function WorkDubcircusPage() {
  return (
    <div className="page text-ink">
      <Navbar />
      <main>
        <div className="h-24 lg:h-28" aria-hidden="true" />
        <DubcircusCaseStudy />
      </main>
      <Footer />
    </div>
  );
}
